import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormArray, FormBuilder } from '@angular/forms';

import { InputComponent } from '../../../shared/input/input.component';
import { InputSelectComponent } from '../../../shared/input-select/input-select.component';
import { ImageUploadDropzoneComponent } from '../../../shared/image-upload-dropzone/image-upload-dropzone.component';
import { InputDateTimeComponent } from '../../../shared/input-datetime/input-datetime.component'
import { RowComponent } from '../../../shared/row/row.component'

import { Image, ImageTag } from '../../../model/hero-report-image/image.model';

@Component({
  selector: 'app-incident-report-step2',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    InputSelectComponent,
    ImageUploadDropzoneComponent,
    InputDateTimeComponent,
    RowComponent
  ],
  templateUrl: './incident-report-step2.component.html',
  styleUrls: ['./incident-report-step2.component.scss'],
})
export class IncidentReportStep2Component implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() deleteable = false;
  @Output() submitForReview = new EventEmitter<any>();

  public ImageTag = ImageTag;

  dispositionOptions = [
    { label: $localize`:@@disposition.puca:PUCA`, value: 'PUCA' },
    { label: $localize`:@@disposition.rsp:RSP`, value: 'RSP' },
    { label: $localize`:@@disposition.bip:BIP`, value: 'BIP' },
    { label: $localize`:@@disposition.notFound:Not Found`, value: 'Not Found' },
  ];

  // gallery state
  imageIndex = 0;
  galleryVisible = false;

  // for the dimensions grid
  dimensionOptions = [
    { label: $localize`:@@dimensions.width:Width (mm)`, formControlName: 'widthCm' },
    { label: $localize`:@@dimensions.length:Length (mm)`, formControlName: 'lengthCm' },
    { label: $localize`:@@dimensions.height:Height (mm)`, formControlName: 'heightCm' },
    { label: $localize`:@@dimensions.diameter:Diameter (mm)`, formControlName: 'diameterCm' },
  ];

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    // Ensure the eodImages FormArray exists
    if (!this.formGroup.get('eodImages')) {
      this.formGroup.addControl('eodImages', this.fb.array([]));
    }
  }

  get eodImages(): Image[] {
    const arr = this.formGroup.get('eodImages') as FormArray;
    return arr?.value as Image[];
  }

  submit() {
    const vals = this.formGroup.value;
    if (vals.disposition === '') {
      this.formGroup.patchValue({ disposition: null });
    }
    this.submitForReview.emit(vals);
  }

  onImageAdd(img: Image) {
    (this.formGroup.get('eodImages') as FormArray).push(this.fb.control(img));
  }

  onDeleteImage(img: Image) {
    const arr = this.formGroup.get('eodImages') as FormArray;
    const idx = arr.value.findIndex((i: any) => i.url === img.url);
    if (idx > -1) arr.removeAt(idx);
  }
}
